// The chosen interval is persisted via DB-backed user settings.
// The "last check" timestamp is per-device and stays in localStorage.

const LAST_CHECK_KEY = 'translate-ai:updateCheck:lastCheck';

export function readLastUpdateCheck(): number | null {
  try {
    const raw = localStorage.getItem(LAST_CHECK_KEY);
    if (raw == null) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function writeLastUpdateCheck(ms: number): void {
  try {
    localStorage.setItem(LAST_CHECK_KEY, String(ms));
  } catch {
    // ignore
  }
}
